import http from "../../http";



// get all labels service
function getServiceRegionsService() {
    return http.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/get-region`);
}

// get all labels service
function getServicesService() {
    return http.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/get-service-category`);
}


// Subcontractors Accounts Count / Accounts Summary
function getAccountStatusCount(){
    return http.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/count`);
}

// Subcontractors List Services
function subcontractorsListService(payload: any){
    return http.post(`${process.env.REACT_APP_BASE_URL}/subcontractor/?page=${payload.page}&perPage=${payload.perPage}`,{
        filters:payload.filters,
        sort:payload.sort
    })
}

// Subcontractors Details Service
function subcontractorDetailsService(payload: any){
    return http.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}`)
}

// Subcontractors upload document Service
function subcontractorUploadDocumentService(payload: any){
    return http.post(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}/document/upload`,
        payload?.formData,
        {
            headers: { "Content-Type": "multipart/form-data" },
        }
    )
}

// Subcontractors upload document Service
function subcontractorDeleteDocumentService(payload: any){
    return http.delete(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}/document/${payload?.docId}`)
}

// Update subcontractor details service
function updateSubcontractorsDocumentService(payload: any){
    return http.put(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}/document/${payload?.docId}`,{
        ...payload?.data
    })
}

// Update Subcontractor Details Service
function updateSubcontractorDetailsService(payload: any){
    const { subId, data} = payload;
    return http.put(`${process.env.REACT_APP_BASE_URL}/subcontractor/${subId}`,
        data
    );
}

// Subcontractor Internal Notes service
function getSubcontractorNotesService(payload: any){
    return http.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}/notes`);
}

// Subcontractor Internal Notes service
function createSubcontractorNoteService(payload: any){
    return http.post(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}/note`, 
        payload?.data
    );
}

// Get Subcontractor Access Token service
function getSubcontractorAccessTokenService(payload: any){
    return http.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/${payload?.subId}/get-token`, 
        payload?.data
    );
}

// Subcontractor Search/Autocomplete Service
function subcontractorSearchService(query: string){
    return http.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/autocomplete?term=${encodeURIComponent(query)}`);
}

// Subcontractor Projects Service
function getSubcontractorProjectsService(payload: any){
    return http.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/tab/${payload?.subId}/projects`);
}

// Subcontractor Payments Service
function getSubcontractorPaymentsService(payload: any){
    return http.get(`${process.env.REACT_APP_BASE_URL}/subcontractor/tab/${payload?.subId}/sub-expense-payments`);
}

// Export All the Subcontractors Service
export const subcontractorsServices = {
    getServiceRegionsService,
    getServicesService,
    getAccountStatusCount,
    subcontractorsListService,
    subcontractorDetailsService,
    subcontractorUploadDocumentService,
    subcontractorDeleteDocumentService,
    updateSubcontractorsDocumentService,
    updateSubcontractorDetailsService,
    getSubcontractorNotesService,
    createSubcontractorNoteService,
    getSubcontractorAccessTokenService,
    subcontractorSearchService,
    getSubcontractorProjectsService,
    getSubcontractorPaymentsService
} 
